// app/javascript/controllers/stop_propagation_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    stop(event:MouseEvent) {
        // Verhindert, dass die Tabellenzeile/Karte den Klick abfängt
        event.stopPropagation();

        // Wir rufen KEIN preventDefault() auf!
        // So kann Rails/Turbo das Formular ganz normal absenden.
    }
}
